// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__1iNAf","method":"styles_method__2g6iH","variant":"styles_variant__3zksd","important":"styles_important__3Vsy6","info":"styles_info__2pasw"};